export const RESET = 'EXCMDEVICE_UPDATE_RESET'
export const SET_ERROR = 'EXCMDEVICE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDEVICE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDEVICE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDEVICE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDEVICE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDEVICE_UPDATE_UPDATE_RETRIEVED'
